var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EMPTY_TEXT, EnvironmentService, HttpCacheType, HttpContentType, HttpHeaderType, HttpMethodType } from "../../common";
import { PhotoCaptureServiceHeader } from '../constants';
import { handleResolveOrRejectResponse } from '../utilities';
export class PhotoCaptureIntelligentDamageDetectionService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    /**
     * POST: Detects damage in images
     */
    detectDamage(companyCode, requestPayload, instanceReferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}photo-based-estimating-orch-api/v1/companies/${companyCode}/damage-detection`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName,
                    [HttpHeaderType.XMI_REQUEST_ID]: instanceReferenceId
                }),
                body: JSON.stringify(requestPayload)
            });
            const response = yield this.fetchWrapper(request);
            if (!response.ok) {
                return yield handleResolveOrRejectResponse(response);
            }
            return this.resolveDamageDetectionResponse(response);
        });
    }
    resolveDamageDetectionResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseText = yield response.text();
            if (!responseText) {
                return {
                    status: String(response.status),
                    message: response.statusText || undefined
                };
            }
            try {
                const parsedResponse = JSON.parse(responseText);
                return {
                    status: String(parsedResponse.status || parsedResponse.statusCode || response.status),
                    message: this.getResponseMessage(parsedResponse, response.statusText)
                };
            }
            catch (_a) {
                return {
                    status: String(response.status),
                    message: responseText
                };
            }
        });
    }
    getResponseMessage(parsedResponse, fallbackMessage) {
        const candidateKeys = ['message', 'statusMessage', 'description', 'errorDescription'];
        for (const key of candidateKeys) {
            const value = parsedResponse[key];
            if (typeof value === 'string' && value) {
                return value;
            }
        }
        return fallbackMessage || undefined;
    }
    /**
     * GET: Retrieves damage detection result by request ID
     */
    getDamageDetection(companyCode, requestId, instanceReferenceId, claimNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = new URLSearchParams();
            if (claimNumber && claimNumber.trim()) {
                queryParams.set('claimNumber', claimNumber);
            }
            const queryString = queryParams.toString();
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}photo-based-estimating-orch-api/v1/companies/${companyCode}/referenceId/${instanceReferenceId}/damage-detection/${requestId}${queryString ? `?${queryString}` : EMPTY_TEXT}`;
            const request = new Request(uri, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_CALLER]: PhotoCaptureServiceHeader.applicationName,
                    [HttpHeaderType.XMI_REQUEST_ID]: instanceReferenceId
                })
            });
            const response = yield this.fetchWrapper(request);
            return yield handleResolveOrRejectResponse(response);
        });
    }
}
//# sourceMappingURL=IntelligentPhotoCaptureDamageDetectionService.js.map